import { render, staticRenderFns } from "./SelectsV2.vue?vue&type=template&id=70da21c4&scoped=true"
import script from "./SelectsV2.vue?vue&type=script&lang=js"
export * from "./SelectsV2.vue?vue&type=script&lang=js"
import style0 from "./SelectsV2.vue?vue&type=style&index=0&id=70da21c4&prod&lang=scss&scoped=true"
import style1 from "./SelectsV2.vue?vue&type=style&index=1&id=70da21c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da21c4",
  null
  
)

export default component.exports